<template>
	<el-container style="min-height: 100vh; display: flex; flex-direction: column;">
		<el-header style="flex-shrink: 0;" class="elheader">
			<MyHeader @getData="getData"></MyHeader>
		</el-header>

		<el-container style="flex: 1; overflow: hidden; display: flex;">
			<el-aside :width="isCollapse ? '60px' : '250px'" :style="{
    overflowY: minw ? 'auto' : 'hidden'
  }">
				<MyAside :msg="isCollapse" />
			</el-aside>

			<el-main style="overflow-y: auto; padding: 0;">
				<div class="mainbackcolor">
					<el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="changeTab">
						<el-tab-pane :closable="false" label="首页" name="/Home"></el-tab-pane>
						<el-tab-pane v-for="(item, index) in editableTabs" :key="item.name" :label="item.title" :name="item.name">
						</el-tab-pane>
					</el-tabs>
				</div>
				<transition name="slide-left" mode="out-in">
					<router-view key="routerView" class="router-view-wrapper" />
				</transition>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import MyAside from "./components/Aside.vue";
	import MyHeader from "./components/Header.vue";

	export default {
		data() {
			return {
				isCollapse: false,
				editableTabsValue: '/Home',
				editableTabs: [],
				minw: false
			}
		},

		methods: {
			getData(data) {
				this.isCollapse = data;
			},
			removeTab(targetName) {
				let tabs = this.editableTabs;
				let activeName = this.editableTabsValue;
				if (activeName === targetName) {
					tabs.forEach((tab, index) => {
						if (tab.name === targetName) {
							let nextTab = tabs[index + 1] || tabs[index - 1];

							if (nextTab) {
								activeName = nextTab.name;

							}
						}
					});
				}

				this.editableTabsValue = activeName;
				if (tabs.length > 1) {
					this.$router.push(activeName)
				} else {
					this.$router.push('/Home')
				}

				this.editableTabs = tabs.filter(tab => tab.name !== targetName);
			},
			changeTab(name) {

				if (name.name == '/Home') {
					sessionStorage.setItem('setIsTabChange', false); // 设置为 true
					this.$router.push(name.name)
				} else {
					sessionStorage.setItem('setIsTabChange', true); // 设置为 true
					this.$router.push(name.name)
				}

			},
			handleResize() {

				const width = window.innerWidth;
				// console.log('width', width);
				this.minw = width <= 1030;
				this.isCollapse = width <= 1030; // 小于等于 768px 时折叠
				// console.log('this.isCollapse', this.isCollapse);
			}
		},
		components: {
			MyAside,
			MyHeader,
		},
		watch: {
			'$route': function(to, from) {
				// 当前路由变化时调用此函数
				// to 是新的路由对象，from 是旧的路由对象
				// console.log('Route changed from', from, 'to', to);
				if (to.fullPath !== '/Home') {

					const Tabs = {
						title: to.meta.label,
						name: to.fullPath
					}
					// 使用 find 方法检查 editableTabs 数组中是否存在 Tabs 对象
					const existingTab = this.editableTabs.find(tab =>
						tab.name === Tabs.name
					);

					// 如果不存在并且不是 /home 路径，就添加到 editableTabs 数组中
					if (!existingTab) {
						this.editableTabs.push(Tabs);
					}

				}
				this.editableTabsValue = to.fullPath;
			}
		},
		mounted() {
			this.handleResize(); // 初始化判断一次
			window.addEventListener('resize', this.handleResize);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize); // 清理事件
		},
	};
</script>

<style scoped>
	html,
	body {
		height: 100%;
		margin: 0;
		padding: 0;
		/* height: ; */
	}

	::v-deep .el-main {
		padding: 0;
		margin: 0;
		background-color: var(--main_backgound);
		display: flex;
		flex-direction: column;
		/* 子元素垂直排列 */
		height: 100%;
		/* 必须有高度 */
		box-sizing: border-box;
	}

	.editableTabsValue {
		background-color: var(--cont_backgound);
		padding: 1rem;
		padding-bottom: 0;
	}

	.el-header {
		padding: 0px;
		margin: 0px;
		border-bottom: 2px solid #e4e9ee;
	}

	.el-aside {
		background: $primary-color;
		transition: width 0.15s;
		box-sizing: border-box;
		flex-shrink: 0;
		height: 100%;
		overflow-x: hidden;
		overflow-y: hidden;

		/* 强制内部元素不超出 */
		&,
		& * {
			max-width: 100%;
			box-sizing: border-box;
		}
	}

	/* 路由视图容器：增加最小高度避免塌陷 */
	.router-view-wrapper {
		/* 👇 核心：flex: 1 表示“剩下的都给我” */
		flex: 1;
		width: 100%;
		background-color: #f5f7fa;

		/* 内容超出时自身滚动 */
		overflow-y: auto;

		/* 动画优化 */
		transform: translateZ(0);
		will-change: transform, opacity;

		/* 可选：内边距 */
		/* padding: 10px; */
		box-sizing: border-box;
	}

	/* 过渡动画样式 */
	.slide-left-enter {
		opacity: 0;
		transform: translate3d(-100%, 0, 0);
	}

	.slide-left-enter-active {
		transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
	}

	.slide-left-leave-to {
		opacity: 0;
		transform: translate3d(100%, 0, 0);
	}

	.slide-left-leave-active {
		transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
		/* 移除了 position: absolute，防止布局抖动 */
	}



	>>>.el-tabs__header {
		margin-bottom: 2px;

	}

	>>>.el-tabs--card>.el-tabs__header {
		border: none;
	}

	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		height: 100%;
	}

	.el-submenu .el-menu {
		transition: all 0.3s ease;
	}

	/* tabs 容器：不伸缩，固定高度 */
	.mainbackcolor {
		position: sticky;
		top: 0;
		z-index: 999;
		background-color: rgba(255, 255, 255, 0.6);
		backdrop-filter: blur(10px);
		-webkit-backdrop-filter: blur(10px);
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

		/* 👇 关键：这个区域不伸缩，保持高度 */
		flex-shrink: 0;
		/* 可设置最小高度 */
		min-height: 42px;
	}


	@media (max-width: 1030px),
	(max-device-width: 1030px) and (orientation: landscape) {
		.el-aside {
			width: 5.6rem !important;

		}

		.slide-left-enter,
		.slide-left-leave-to {
			transform: translateX(-100%);
			opacity: 0;
		}

		.slide-left-enter-active,
		.slide-left-leave-active {
			transition: transform 0.3s linear, opacity 0.3s linear;
		}


	}

	@media(max-width: 1030px) and (device-pixel-ratio: >=2) {
		.el-aside {
			width: 2.75rem !important;
		}

		.slide-left-enter,
		.slide-left-leave-to {
			transform: translateX(-100%);
			opacity: 0;
		}

		.slide-left-enter-active,
		.slide-left-leave-active {
			transition: transform 0.3s linear, opacity 0.3s linear;
		}


	}
</style>